// react-device-detect ships a ~33KB UA-parser regex DB. Load it as its own
// chunk (dynamic import) instead of in the entry bundle, and expose the few
// values the app uses through a synchronously-readable cache. The import is
// kicked off at module load, so the values are warm within a tick — before any
// post-interaction read (login/register/deposit meta, download UI). Components
// that render device-dependent UI use useDeviceDetect() so they re-render once
// the cache warms; imperative callers read getDeviceDetect() directly.
export interface DeviceDetect {
  browserName: string
  mobileModel: string
  isMobile: boolean
  isChrome: boolean
  isIOS: boolean
}

// Conservative defaults until the chunk resolves. getDeviceInfo() always also
// sends the full userAgent, so browserName/mobileModel are supplementary.
let cache: DeviceDetect = {
  browserName: '',
  mobileModel: '',
  isMobile: false,
  isChrome: false,
  isIOS: false,
}

export const deviceDetectReady: Promise<void> = import('react-device-detect')
  .then(m => {
    cache = {
      browserName: m.browserName,
      mobileModel: m.mobileModel,
      isMobile: m.isMobile,
      isChrome: m.isChrome,
      isIOS: m.isIOS,
    }
  })
  .catch(() => {
    /* keep the conservative defaults if the chunk fails to load */
  })

export const getDeviceDetect = (): DeviceDetect => cache
